import { forwardRef } from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "../lib/cn";

export interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> {}

/** w-11 h-6 toggle — raised track off, amber (surface-toggle) track on. */
export const Switch = forwardRef<
  React.ComponentRef<typeof SwitchPrimitive.Root>,
  SwitchProps
>(({ className, ...props }, ref) => {
  return (
    <SwitchPrimitive.Root
      ref={ref}
      className={cn(
        // Track: 44x24 pill, bordered in both states so geometry is stable
        "inline-flex h-6 w-11 shrink-0 items-center rounded-full border border-border-control bg-surface-raised outline-none transition-colors duration-150",
        // Focus
        "focus-visible:ring-2 focus-visible:ring-border-focused focus-visible:ring-offset-1 focus-visible:ring-offset-surface-default",
        // On: surface-toggle is the primary amber, one step calmer in dark mode
        "data-[state=checked]:border-transparent data-[state=checked]:bg-surface-toggle",
        // Disabled
        "disabled:cursor-not-allowed disabled:opacity-38",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          // Thumb: 18px white (on-inverse is mode-locked) circle
          "block size-[18px] translate-x-0.5 rounded-full bg-on-inverse shadow-sm transition-transform duration-150 will-change-transform",
          "data-[state=checked]:translate-x-[22px]",
        )}
      />
    </SwitchPrimitive.Root>
  );
});
Switch.displayName = "Switch";
